import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';

const propTypes = {
  children: PropTypes.any,
};

export default class Menu extends Component {

  constructor(props, context) {
    super(props, context);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(event) {
    event.preventDefault();
    // event.stopPropagation();
  }


  render() {
    const { className } = this.props;
    return (
      <div
          className={classNames(className, 'video-react-menu video-react-lock-showing')}
        role="presentation"
        onClick={this.handleClick}
      >
        <ul className="video-react-menu-content">
          {this.props.children}
        </ul>
      </div>
    );
  }
}

Menu.propTypes = propTypes;
Menu.displayName = 'Menu';

